export default __webpack_public_path__ + "static/media/1.c6df3cb9.jpg";